<mat-card class="default">
  <div
    style="position: absolute; right: 1rem; top: 6px; z-index: 2"
  >
    <mmx-appointment-portal-menu
      *ngIf="appointment$ | async as appointment"
      [appointment]="appointment"
      type="eligibility"
    >
    </mmx-appointment-portal-menu>
    <button
      *appHasPermission="'patient.eligibility.edit'"
      mat-stroked-button
      type="button"
      (click)="openPullEligibilityDialog()"
    >
      <mat-icon>policy</mat-icon>
      {{ 'patient-details.eligibility-card.button-pull-eb' | translate }}
    </button>
  </div>
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    animationDuration="0ms"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab>
      <ng-container *ngIf="(primaryEligibility$ | async) as primaryEligibility; else noPrimaryEligibility">
        <ng-template mat-tab-label>
          <mat-icon>{{ getShield(primaryEligibility) }}</mat-icon>
          {{ 'common.primary' | translate }}
        </ng-template>
        <mmx-eligibility-card
          [serviceCodes]="serviceCodes$ | async"
          [placeTypes]="placeOfService$ | async"
          [eligibility]="primaryEligibility"
          [insuranceType]="insuranceType.PRIMARY"
          (estimation)="updateEstimation()"
        ></mmx-eligibility-card>
      </ng-container>
      <ng-template #noPrimaryEligibility>
        <ng-template mat-tab-label>
          <mat-icon>shield</mat-icon>
          {{ 'common.primary' | translate }}
        </ng-template>
        <mat-card-content>
          {{ 'patient-details.eligibility-card.no-eligibility' | translate }}
          <ng-container *ngIf="getPatientInsurance(insuranceType.PRIMARY) as patientInsurance">
            <div class="text-primary">Carrier: {{ patientInsurance.clinicCarrierName }}</div>
            <div class="text-secondary">Member ID: {{ patientInsurance.memberId }}</div>
          </ng-container>
        </mat-card-content>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-container *ngIf="(secondaryEligibility$ | async) as secondaryEligibility; else noSecondaryEligibility">
        <ng-template mat-tab-label>
          <mat-icon>{{ getShield(secondaryEligibility) }}</mat-icon>
          {{ 'common.secondary' | translate }}
        </ng-template>
        <mmx-eligibility-card
          [serviceCodes]="serviceCodes$ | async"
          [placeTypes]="placeOfService$ | async"
          [eligibility]="secondaryEligibility"
          [insuranceType]="insuranceType.SECONDARY"
          (estimation)="updateEstimation()"
        ></mmx-eligibility-card>
      </ng-container>
      <ng-template #noSecondaryEligibility>
        <ng-template mat-tab-label>
          <mat-icon>shield</mat-icon>
          {{ 'common.secondary' | translate }}
        </ng-template>
        <mat-card-content>
          {{ 'patient-details.eligibility-card.no-eligibility' | translate }}
          <ng-container *ngIf="getPatientInsurance(insuranceType.SECONDARY) as patientInsurance">
            <div class="text-primary">Carrier: {{ patientInsurance.clinicCarrierName }}</div>
            <div class="text-secondary">Member ID: {{ patientInsurance.memberId }}</div>
          </ng-container>
        </mat-card-content>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-container *ngIf="(tertiaryEligibility$ | async) as tertiaryEligibility; else noTertiaryEligibility">
        <ng-template mat-tab-label>
          <mat-icon>{{ getShield(tertiaryEligibility) }}</mat-icon>
          {{ 'common.tertiary' | translate }}
        </ng-template>
        <mmx-eligibility-card
          [serviceCodes]="serviceCodes$ | async"
          [placeTypes]="placeOfService$ | async"
          [eligibility]="tertiaryEligibility"
          [insuranceType]="insuranceType.TERTIARY"
          (estimation)="updateEstimation()"
        ></mmx-eligibility-card>
      </ng-container>
      <ng-template #noTertiaryEligibility>
        <ng-template mat-tab-label>
          <mat-icon>shield</mat-icon>
          {{ 'common.tertiary' | translate }}
        </ng-template>
        <mat-card-content>
          {{ 'patient-details.eligibility-card.no-eligibility' | translate }}
          <ng-container *ngIf="getPatientInsurance(insuranceType.TERTIARY) as patientInsurance">
            <div class="text-primary">Carrier: {{ patientInsurance.clinicCarrierName }}</div>
            <div class="text-secondary">Member ID: {{ patientInsurance.memberId }}</div>
          </ng-container>
        </mat-card-content>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
